'use client';

import * as React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { AnalyticsProvider } from '@workspace/analytics/hooks/use-analytics';
import { TooltipProvider } from '@workspace/ui/components/tooltip';
import { ThemeProvider } from '@workspace/ui/hooks/use-theme';

import { env } from '~/env';

export function Providers({
  children
}: React.PropsWithChildren): React.JSX.Element {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
    >
      <AnalyticsProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <TooltipProvider>{children}</TooltipProvider>
        </ThemeProvider>
      </AnalyticsProvider>
    </GoogleReCaptchaProvider>
  );
}
